import { render, staticRenderFns } from "./priority-dropdown.vue?vue&type=template&id=07477e42"
import script from "./priority-dropdown.vue?vue&type=script&lang=js"
export * from "./priority-dropdown.vue?vue&type=script&lang=js"
import style0 from "./priority-dropdown.vue?vue&type=style&index=0&id=07477e42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports